exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-wrapper[data-v-2d2bbdc2] {\n  /*text-align:center;*/\n}\n", ""]);

// exports
